const initial_state = {
  parent_list: [],
  blog_list: [],
  parent_object: {},
  selected_blog: null,
  folder_blogs: [],
  picture_url: "",
};

export default function editor_reducer(state = initial_state, action) {
  switch (action.type) {
    case "set_value_editor":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
}
